/**
 * Syncs Mariner onboarding opt-in to cart attributes (order note attributes at checkout).
 * Klaviyo: trigger on Placed Order when note attribute "Mariner_onboarding_opt_in" equals "yes".
 *
 * Default: checked unless the customer explicitly opted out (attribute "no").
 */
(function () {
  const ATTR_KEY = 'Mariner_onboarding_opt_in';
  const DEBOUNCE_MS = 280;

  let timer;
  let syncingDefault = false;

  function syncCheckboxes(checked) {
    document.querySelectorAll('[data-ms-cart-marketing-opt-in]').forEach((el) => {
      if (el instanceof HTMLInputElement) el.checked = checked;
    });
  }

  function updateCartAttribute(value) {
    const attrs = {};
    attrs[ATTR_KEY] = value;

    return fetch(window.routes.cart_update_url, {
      ...fetchConfig('json'),
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function applyCartState(cart) {
    const val = String((cart.attributes && cart.attributes[ATTR_KEY]) || '')
      .trim()
      .toLowerCase();
    syncCheckboxes(val !== 'no');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ms-marketing-opt-in', cartData: cart });
    }
  }

  function syncDefaultOptIn() {
    if (syncingDefault) return;

    const boxes = document.querySelectorAll('[data-ms-cart-marketing-opt-in]');
    if (!boxes.length) return;

    const wantsYes = Array.from(boxes).some(
      (el) => el instanceof HTMLInputElement && el.checked
    );
    if (!wantsYes) return;

    syncingDefault = true;
    fetch(window.routes.cart_url + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart read failed');
        return r.json();
      })
      .then(function (cart) {
        const current = String((cart.attributes && cart.attributes[ATTR_KEY]) || '')
          .trim()
          .toLowerCase();
        if (current === 'yes' || current === 'no') {
          syncCheckboxes(current !== 'no');
          return null;
        }
        return updateCartAttribute('yes');
      })
      .then(function (cart) {
        if (cart) applyCartState(cart);
      })
      .catch(function () {
        /* leave checkbox state as rendered */
      })
      .finally(function () {
        syncingDefault = false;
      });
  }

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!target || !target.matches || !target.matches('[data-ms-cart-marketing-opt-in]')) return;

    clearTimeout(timer);
    timer = setTimeout(function () {
      const checked = target instanceof HTMLInputElement && target.checked;

      updateCartAttribute(checked ? 'yes' : 'no')
        .then(applyCartState)
        .catch(function () {
          if (target instanceof HTMLInputElement) target.checked = !checked;
        });
    }, DEBOUNCE_MS);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDefaultOptIn);
  } else {
    syncDefaultOptIn();
  }

  document.addEventListener('shopify:section:load', syncDefaultOptIn);
})();
